var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSportLimitFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.234 21.969a9.96 9.96 0 01-5.159-1.902 10.738 10.738 0 003.63-7.333h1.53v9.235zM15.028 12.889a9.993 9.993 0 003.464 6.705 9.97 9.97 0 01-5.758 2.375v-9.235h1.961c.11.054.22.106.333.155zM8.201 12.734a9.245 9.245 0 01-3.28 6.347A9.982 9.982 0 012 12.734h6.201zM21.969 12.734a9.97 9.97 0 01-2.41 5.797 8.503 8.503 0 01-2.958-5.162 7.537 7.537 0 004.704-.635h.664z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0a6 6 0 110 12 6 6 0 010-12zm0 8a.75.75 0 100 1.5.75.75 0 000-1.5zm0-5.45a.75.75 0 00-.75.75v3a.75.75 0 001.5 0v-3a.75.75 0 00-.75-.75z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.922 4.889a9.244 9.244 0 013.28 6.345H2A9.98 9.98 0 014.922 4.89zM11.234 2.759A7.471 7.471 0 0010.5 6c0 1.16.264 2.26.734 3.241v1.993H9.705a10.738 10.738 0 00-3.63-7.333A9.96 9.96 0 0111.234 2v.759z",
    fill: "currentColor"
  })));
}
SvgSportLimitFilled.displayName = 'SportLimitFilled';
export default SvgSportLimitFilled;